module.exports = __webpack_public_path__ + "img/Banner2.57f872a8.jpg";